import { SignUp, useAuth } from '@clerk/react';
import { Box, Typography, Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useTenant from '../../hooks/useTenant';
import AuthLayout from '../../layouts/Auth';
import useClerkAppearance from './useClerkAppearance';
import { CONVITE_JURADO_EMAIL_KEY } from '../../pages/jurado/ConviteAceite';

function ClerkSignUp() {
  const { branding, selectedSlug } = useTenant();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isSignedIn, isLoaded } = useAuth();
  const appearance = useClerkAppearance();
  // Aguarda branding antes de montar o <SignUp>. Sem isso, o appearance muda
  // do default pro do tenant depois que o user preenche o email, o que re-dispara
  // efeitos internos do Clerk e manda um segundo email de verificação.
  const brandingPronto = !selectedSlug || branding !== null;

  // Email pré-preenchido de convite de jurado
  const [emailConvite, setEmailConvite] = useState(null);

  useEffect(() => {
    const email = sessionStorage.getItem(CONVITE_JURADO_EMAIL_KEY);
    if (email) {
      setEmailConvite(email);
    }
  }, []);

  const redirectAfterSignup = sessionStorage.getItem('konq.conviteJuradoId')
    ? '/cadastro-jurado'
    : '/cadastro-produtor';

  useEffect(() => {
    if (isSignedIn) {
      const conviteId = sessionStorage.getItem('konq.conviteJuradoId');
      if (conviteId) {
        navigate('/cadastro-jurado', { replace: true });
      } else {
        navigate('/cadastro-produtor', { replace: true });
      }
    }
  }, [isSignedIn, navigate]);

  const pronto = isLoaded && brandingPronto;

  return (
    <AuthLayout>
      <Box sx={{ minHeight: 480, opacity: pronto ? 1 : 0, transition: 'opacity 0.3s ease' }}>
        {emailConvite && (
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight={600}>
              {t('Judge invitation')}
            </Typography>
            <Typography variant="caption" component="div">
              {t('Use the email {{email}} to create your account.', { email: emailConvite })}
            </Typography>
          </Alert>
        )}
        {pronto && (
          <SignUp
            routing="virtual"
            signInUrl="/login"
            fallbackRedirectUrl={redirectAfterSignup}
            forceRedirectUrl={redirectAfterSignup}
            appearance={appearance}
            initialValues={emailConvite ? { emailAddress: emailConvite } : undefined}
            unsafeMetadata={emailConvite ? { conviteEmail: emailConvite } : undefined}
          />
        )}
      </Box>
    </AuthLayout>
  );
}

export default ClerkSignUp;
